import { ReviewTab } from "@/components/ai/review/ReviewTab";
import type { ReviewComment, PendingCommentSelection, CachedCodeLine } from "@/components/ai/review/types";
import { cn } from "@/components/podkit/lib/cn";
import type { PlainEnvironment } from "@/queries/environment-queries";
import type { EnvironmentGitStatus } from "gitpod-next-api/gitpod/v1/environment_pb";
import type { FC } from "react";

export type ReviewTabPanelProps = {
    environment: PlainEnvironment;
    comments: ReviewComment[];
    onEditComment: (commentId: string, content: string) => void;
    onRemoveComment: (commentId: string) => void;
    onNavigateToComment: (comment: ReviewComment) => void;
    onSubmitReview: (selectedComments: ReviewComment[], additionalContext?: string) => void;
    onDismissReview: () => void;
    onStartReview?: () => void;
    isStartReviewDisabled: boolean;
    isSubmitting: boolean;
    pendingSelection: PendingCommentSelection | null;
    onAddComment: (filePath: string, startLine: number, endLine: number, content: string) => void;
    onClearPendingSelection: () => void;
    onUpdateCodeContext: (commentId: string, hash: string, lines: CachedCodeLine[]) => void;
    gitStatus?: EnvironmentGitStatus;
    onLineSelectionForComment: (selection: PendingCommentSelection) => void;
    isHidden: boolean;
};

export const ReviewTabPanel: FC<ReviewTabPanelProps> = ({
    environment,
    comments,
    onEditComment,
    onRemoveComment,
    onNavigateToComment,
    onSubmitReview,
    onDismissReview,
    onStartReview,
    isStartReviewDisabled,
    isSubmitting,
    pendingSelection,
    onAddComment,
    onClearPendingSelection,
    onUpdateCodeContext,
    gitStatus,
    onLineSelectionForComment,
    isHidden,
}) => {
    return (
        <div
            id="review-panel"
            role="tabpanel"
            aria-labelledby="review-tab"
            className={cn("flex min-h-0 flex-1 flex-col", isHidden && "hidden")}
        >
            <ReviewTab
                environment={environment}
                comments={comments}
                onEditComment={onEditComment}
                onRemoveComment={onRemoveComment}
                onNavigateToComment={onNavigateToComment}
                onSubmitReview={onSubmitReview}
                onDismissReview={onDismissReview}
                onStartReview={onStartReview}
                isStartReviewDisabled={isStartReviewDisabled}
                isSubmitting={isSubmitting}
                pendingSelection={pendingSelection}
                onAddComment={onAddComment}
                onClearPendingSelection={onClearPendingSelection}
                onUpdateCodeContext={onUpdateCodeContext}
                gitStatus={gitStatus}
                onLineSelectionForComment={onLineSelectionForComment}
            />
        </div>
    );
};
